import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MainFacade } from 'src/app/pages/main.facade';

@Component({
  selector: 'app-alien',
  templateUrl: './alien.component.html',
  styleUrls: ['./alien.component.scss']
})
export class AlienComponent implements OnInit {
  public topSpenders$: Observable<any>|undefined;
  constructor(private mainfacade:MainFacade) { }

  ngOnInit(): void {
    this.createSubscriptions();
  }

  createSubscriptions(){
    this.topSpenders$ = this.mainfacade.topSpenders$;
    this.mainfacade.getTopSpenders();
  }
  

}
